import Auth0 from "react-native-auth0";

import { ScreenPath } from "@/constants/Navigation";
import ProcessEnvironment from "@/constants/ProcessEnvironment";

const Audience = ProcessEnvironment.Auth0Audience;
const CallbackUrl =
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, sonarjs/different-types-comparison -- sonarqube insists on this being globalThis, but sonar lint complains about it
  globalThis.window === undefined
    ? undefined
    : `${globalThis.window.location.origin}/${ScreenPath.WebAuth0Callback}`;
const Scope = "profile email offline_access";

const Auth0ClientOptions = {
  authorizationParams: {
    audience: Audience,
    redirect_uri: CallbackUrl,
    scope: Scope,
  },
  cacheLocation: "localstorage",
  clientId: ProcessEnvironment.Auth0WebClientId,
  domain: ProcessEnvironment.Auth0Domain,
  // the auth0 react-native-web SDK has useDPoP set to 'true' by default
  // however, Auth0 with DPoP is not used anywhere by equip (ie, my-equip, equip-vesta)
  // eslint-disable-next-line @typescript-eslint/naming-convention
  useDPoP: false,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  useRefreshTokens: true,
  // similarly, my-equip defaults to false, but auth0 RN-web SDK defaults to true
  // eslint-disable-next-line @typescript-eslint/naming-convention
  useRefreshTokensFallback: false,
} as const;
const Auth0Client = new Auth0(Auth0ClientOptions);

const WebAuth0GetCredentialsArgs = {
  minTtl: undefined,
  parameters: { audience: Audience },
  scope: `openid ${Scope}`,
} as const;

const WebAuth0AuthorizeProps = {
  audience: Audience,
  // every authorize() call should route to the Auth0 Universal Login Page
  // no silent re-auth, no prompting for selections, etc
  prompt: "login",
  redirectUrl: CallbackUrl,
  scope: Scope,
} as const;

const getWebViewAccessTokenFromAuth0 = async (): Promise<string> => {
  const { accessToken } = await Auth0Client.credentialsManager.getCredentials(
    WebAuth0GetCredentialsArgs.scope,
    WebAuth0GetCredentialsArgs.minTtl,
    WebAuth0GetCredentialsArgs.parameters,
    false,
  );
  return accessToken;
};

export {
  Auth0Client,
  Auth0ClientOptions,
  getWebViewAccessTokenFromAuth0,
  WebAuth0AuthorizeProps,
  WebAuth0GetCredentialsArgs,
};
